import React from "react";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import Signature from "../../../../../shared/input/Signature";

interface IProps {
    value?: string,
    onChange?: (value?: string) => void
    options: IFieldOptions
}

interface IState {

}

class FormFieldSignature extends React.Component<IProps, IState> {
    render() {
        const {placeholder, disabled, addSignatureWaterMark, allowSavedSignature} = this.props.options
        const {value, onChange} = this.props

        return (
            <Signature waterMark={addSignatureWaterMark} disabled={disabled} allowGenerating={false} placeholder={placeholder} onChange={onChange} value={value} suggestSaved={allowSavedSignature}/>
        )
    }
}

export default FormFieldSignature